module.exports = __webpack_public_path__ + "static/img/appdow_bk2_web_nr.bbe87d4.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk2_web_nr.gif
// module id = BPaX
// module chunks = 4